// extracted by mini-css-extract-plugin
module.exports = {"image":"qbank-image_image__CxD_1","initialHeight":"qbank-image_initialHeight__Mil_L"};